module.exports = __webpack_public_path__ + "img/play.616ea1c1.png";